<div class="grid-row">
  <div class="row">
    <div class="col-sm-1 experience-type-id-col truncate">
      <span class="experience-type-id">{{experienceType.id}}</span>
    </div>
    <div class="col-sm-2 experience-type-name-col truncate">
      <span class="experience-type-name">{{experienceType.title["en-us"]}}</span>
    </div>

    <div class="col-sm-2 experience-type-category-col">
      <span class="industries truncate">
        {{getFirstItemName(experienceType, categoryIndex.Industries)}}
      </span>
      @if (hasAdditionalItems(experienceType, categoryIndex.Industries)) {
        <div class="additional-industries-bubble">
          <span class="additional-industries-bubble__count">
            +{{getAdditionalCount(experienceType, categoryIndex.Industries)}}
          </span>
        </div>
      }
    </div>

    <div class="col-sm-2 experience-type-category-col">
      <span class="companyTypes truncate">
        {{getFirstItemName(experienceType, categoryIndex.CompanyTypes)}}
      </span>
      @if (hasAdditionalItems(experienceType, categoryIndex.CompanyTypes)) {
        <div class="additional-industries-bubble">
          <span class="additional-industries-bubble__count">
            +{{getAdditionalCount(experienceType, categoryIndex.CompanyTypes)}}
          </span>
        </div>
      }
    </div>

    <div class="col-sm-2 experience-type-category-col">
      <span class="outcomes truncate">
        {{getFirstItemName(experienceType, categoryIndex.Outcomes)}}
      </span>
      @if (hasAdditionalItems(experienceType, categoryIndex.Outcomes)) {
        <div class="additional-industries-bubble">
          <span class="additional-industries-bubble__count">
            +{{getAdditionalCount(experienceType, categoryIndex.Outcomes)}}
          </span>
        </div>
      }
    </div>

    <div class="col-sm-1 truncate">
      <span>{{experienceType.created_at | date:'shortDate'}}</span>
    </div>

    <div class="col-sm-1 truncate">
      <span>{{experienceType.updated_at | date:'shortDate'}}</span>
    </div>

    <div class="color-sm-1 action-column">
      <i id="edit-experience-type-btn-{{experienceType.id}}" class="fa fa-pencil" aria-hidden="true" (click)="emitEditEvent()"></i>
      @if (hasDetailsToShow(experienceType)) {
        <div class="expander-div">
          @if (!detailsOpen) {
            <i (click)="toggleDetails()" class="fa fa-caret-right expander-image"></i>
          }
          @if (detailsOpen) {
            <i (click)="toggleDetails()" class="fa fa-caret-down expander-image"></i>
          }
        </div>
      }
    </div>
  </div>
</div>

@if (hasDetailsToShow(experienceType) && detailsOpen) {
  <div class="experience-type-detail">
    <div class="row grid-row">
      <div class="col-sm-3"></div>
      <div class="col-sm-2">
        @for (industry of getAdditionalItems(experienceType, categoryIndex.Industries); track industry) {
          <div class="additional-industry">
            {{industry}}
          </div>
        }
      </div>
      <div class="col-sm-2">
        @for (companyType of getAdditionalItems(experienceType, categoryIndex.CompanyTypes); track companyType) {
          <div class="additional-industry">
            {{companyType}}
          </div>
        }
      </div>
      <div class="col-sm-2">
        @for (outcome of getAdditionalItems(experienceType, categoryIndex.Outcomes); track outcome) {
          <div class="additional-industry">
            {{outcome}}
          </div>
        }
      </div>
    </div>
  </div>
}
